import { Injectable } from '@angular/core';
import { RequestHelperProvider } from './request-helper';
import utils from './../utils';
import { BookingBookModel } from '../_models/booking/booking-book.model';
import { BookingRequest, SplitBookingRequest } from '../_models/booking/booking-request.model';
import { RemarksTypes } from '../enums';
import { PrintBookingPDF } from '../_models/booking/print-booking-pdf';
import { BookingPrepayModel } from '../_models/booking/booking-prepay.model';
import { CryptoService } from './crypto.service';
import { StorageKeys } from '../_constants';
import { StorageServiceProvider } from './services';
import { Moment } from 'moment';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root' 
})
export class GatewayServiceProvider {

    private defaultRemoteServer: string = utils.GetGetwayRemoteDomain();
    private defaultUIDefIDKey: string = `45366299-9083-497b-8343-a8f701521358`;
    private defaultCustomerKey: string = `C93F949C-41B8-4C9E-95AA-B030B31F6F3F`;

    constructor(private helper: RequestHelperProvider, public cryptoService: CryptoService,
        private storage: StorageServiceProvider) {

    }

    getUIDefIDKey() {
        return this.defaultUIDefIDKey;
    }
    // private getAgentUsernamePassword(callback: any) {
    //     this.sqlite.create(this.options)
    //         .then((db: SQLiteObject) => {
    //             this.db = db;
    //             this.db.executeSql(`Select Key,Value from Settings where Key in ('AgentUsername','AgentPassword') `, {})
    //                 .then(res => {
    //                     let values = Array.apply(null, { length: res.rows.length }).map(Number.call, Number).map(i => res.rows.item(i));
    //                     let Username;
    //                     let Password;
    //                     for (let i = 0; i < values.length; i++) {
    //                         if (values[i].Key == "AgentUsername") {
    //                             Username = values[i].Value;
    //                         }
    //                         if (values[i].Key == "AgentPassword") {
    //                             Password = values[i].Value;
    //                         }
    //                     }
    //                     callback(Username, Password);
    //                 });
    //         });
    // }
    getTenantID() {
        return localStorage.getItem('tenatId');
    }

    resolveRemoteHeader(callback) {

        callback(this.defaultRemoteServer, this.defaultCustomerKey, this.getGatewaySessionId(), this.defaultUIDefIDKey, this.getTenantID());

    }
    getGatewaySessionId() {
        return localStorage.getItem('GatewaySession');
    }
    // getAgentSessionId(callback: any, failedCalledback?: any) {
    //     this.sqlite.create(this.options)
    //         .then((db: SQLiteObject) => {
    //             this.db = db;
    //             this.db.executeSql(`Select Value from Settings where Key='AgentSession'`, {})
    //                 .then(res => {
    //                     var settingValue = res.rows.length > 0 ? res.rows.item(0).Value : this.DefaultSession;
    //                     callback(settingValue);
    //                 });
    //         });
    // }
    // remoteValidate(callback, ErrorCallback) {
    //   this.getUIDefIDKey((uiDefId) => {
    //     this.getAgentUsernamePassword((Username, Password) => {
    //       this.helper.Post((data) => {
    //         this.saveGatewaySession(data.SessionID, () => callback(this.DefaultRemoteServer, this.DefaultCustomerKey, data.SessionID, uiDefId));
    //       }, `${this.DefaultRemoteServer}/culturahub/RESTSecurityWebService/Authenticate`, {
    //           Username: Username,
    //           Password: Password,
    //           DeviceName: "HOPPER"
    //         }, this.DefaultCustomerKey, null, uiDefId, ErrorCallback);
    //     })
    //   });
    // }
    // remoteValidate(callback, ErrorCallback) {
    //     this.getUIDefIDKey((uiDefId) => {
    //         this.getAgentUsernamePassword((Username, Password) => {
    //             console.log(Username, Password);
    //             if (Username && Password) {
    //                 this.helper.PostServerCommand(`/culturahub/RESTSecurityWebService/Authenticate`, {
    //                     'Username': Username,
    //                     'Password': Password,
    //                     'DeviceName': "HOPPER",
    //                     'UIDefID': uiDefId
    //                 }, (data) => {
    //                     console.log(data);
    //                     this.saveAgentSession(data.SessionID, () => callback(this.DefaultRemoteServer, this.DefaultCustomerKey, data.SessionID, uiDefId));
    //                 }, ErrorCallback);
    //             } else {
    //                 callback(this.DefaultRemoteServer, this.DefaultCustomerKey, null, uiDefId)
    //             }
    //         });
    //     });
    // }

    // saveAgentSession(sessionID: string, callback: any) {
    //     this.storage.get('settings').then((settings) => {
    //         settings.agentSessionId = sessionID;
    //         this.storage.set('settings', settings);
    //         let queries = [`INSERT INTO Settings Select 'AgentSession','${sessionID}' Where Not Exists(Select 1 from Settings where Key = 'AgentSession');`, ` Update Settings set Value='${sessionID}' where Key='AgentSession';`]
    //         this.db.sqlBatch(queries).then((res) => {
    //             if (callback) {
    //                 callback(res);
    //             }
    //         });
    //     });
    // }
    getLiveDatasets(callback, FailedCallback) {
        this.helper.PostServerCommand(`/culturahub/RESTCommandWebService/ExecuteServerCommand/DatasetCommandProcessor/GetDatasets`, {},
            (data) => {
                callback(data);
            }, (error) => FailedCallback(error));
    }


    getAgentVersion(callback, FailedCallback) {
        this.helper.PostServerCommand(`/culturahub/RESTCommandWebService/ExecuteServerCommand/AgentProcessor/GetSystemInfo`, {},
            (response) => {
                callback(response);
            }, FailedCallback);
    }

    getAgentType(callback, FailedCallback) {
        this.helper.PostServerCommand(`/culturahub/RESTCommandWebService/ExecuteServerCommand/AgentProcessor/GetFilesInfo`, {},
            (response) => {
                callback(response);
            }, FailedCallback);
    }
    postBooking(body, isVoid = false): Promise<any> {
        //body.location = utils.getLocation();
        body.isFromSalesApp = true;
        return new Promise((resolve, reject) => {
            body.isFromSalesApp = true;
            // let fullRemarks = "";
            // ACC-1987 - remarks logic updated
            //remarks 6 = Book Program 
            //remarks 5 = Pending Agreement Status
            //remarks 4 = Farm and Field value

            if (body.bookingBook)
                this.fillBookingRemarks(body);
            else if (body.bookingPrepay)
                this.fillPrepayRemarks(body);
            else if (body.bookingQuote) {
                this.fillQuoteRemarks(body);
            }
            // let remarksLength = 250;
            // if (body.bookingBook && (body.pendingAgreementConfig || body.bookingBook.bookingProgram)) {
            //     if (body.pendingAgreementConfig && !body.bookingBook.bookingProgram) {
            //         this.mapBookingRemarks(body.bookingBook, remarksLength);
            //     } else {
            //         this.mapBookingRemarks(body.bookingBook, remarksLength - 50);
            //     }
            // }
            // else if (body.bookingPrepay && body.pendingAgreementConfig) {
            //     this.mapPrepayRemarks(body.bookingPrepay, remarksLength);
            // }

            let dataSet: any = this.storage.get(StorageKeys.DataSet);
            let agrisLicense = JSON.parse(localStorage.getItem('agrisLicense'));
            let settings = this.storage.get(StorageKeys.Settings);;
            var userId = agrisLicense.username;
            let remoteUrl = utils.GetSalesReviewRemoteServer();
            remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');
            remoteUrl = `${remoteUrl}/Bookings/Booking`;
            var User = {
                "UserId": userId
            };
            body.User = User;
            body.AgentId = localStorage.getItem('AgentId');
            body.TenantId = this.storage.get(StorageKeys.DataSet).TenantID;

            // if (isVoid) {
            //     body.approveBookingRequest.status = "V";
            //     // same booking number  => pro user -> type booking -> Asr Same number  true 
            //     body.approveBookingRequest.isSameNumber = false//  ( IsProUser == true && IsSameNumber == true &&  body.bookingBook != null && body.BookingNumber && body.isQuoteConverted ==true  ) ? true : false;

            //     body.approveBookingRequest.sessionId = settings ? settings.agentSessionId : '';
            //     if (agrisLicense) {
            //         body.approveBookingRequest.user = agrisLicense.username;
            //         body.approveBookingRequest.password = agrisLicense.password;
            //         body.approveBookingRequest.decryptedPassword = agrisLicense.beforeEncrptPassword;
            //         body.approveBookingRequest.agrisSession = agrisLicense.agrisLicense;
            //     }
            //     body.approveBookingRequest.tenantId = dataSet ? dataSet.TenantID : '';
            //     remoteUrl = utils.GetSalesReviewRemoteServer();
            //     remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');
            //     remoteUrl = `${remoteUrl}/Bookings/approvebooking`;
            // }
            //else 

            // body.bookingItems[0].id="CORN@@12154";
           
            if (body.isAutoApprove) {
                let IsSameNumber = localStorage.getItem('isSameBookingNumber') === 'true' ? true : false;
                let IsProUser = this.cryptoService.dencryptString(localStorage.getItem('ProUser')) === 'true' ? true : false;
                body.approveBookingRequest.status = "";
                // same booking number  => pro user -> type booking -> Asr Same number  true 
                //body.approveBookingRequest.isSameNumber = (IsProUser == true && IsSameNumber == true && body.bookingBook && body.bookingNumber && body.isQuoteConverted == true) ? true : false;
                /// booking number is empty do we need to check booking number over here ???
                body.approveBookingRequest.isSameNumber = (IsProUser == true && IsSameNumber == true && body.bookingBook && body.isQuoteConverted == true) ? true : false;

                body.approveBookingRequest.sessionId = settings ? settings.agentSessionId : '';
                if (agrisLicense) {
                    body.approveBookingRequest.user = agrisLicense.username;
                    body.approveBookingRequest.password = agrisLicense.password;
                    body.approveBookingRequest.decryptedPassword = agrisLicense.beforeEncrptPassword;
                    body.approveBookingRequest.agrisSession = agrisLicense.agrisLicense;
                }
                body.approveBookingRequest.tenantId = dataSet ? dataSet.TenantID : '';
                remoteUrl = utils.GetSalesReviewRemoteServer();
                remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');
                // Exact Agirs Error Message Show
                remoteUrl = `${remoteUrl}/Bookings/bookingAndApprove`;
            }
            else if (body.approveBookingRequest.status) {
                body.approveBookingRequest.sessionId = settings ? settings.agentSessionId : '';
                if (agrisLicense) {
                    body.approveBookingRequest.user = agrisLicense.username;
                    body.approveBookingRequest.password = agrisLicense.password;
                    body.approveBookingRequest.decryptedPassword = agrisLicense.beforeEncrptPassword;
                    body.approveBookingRequest.agrisSession = agrisLicense.agrisLicense;
                }
                body.approveBookingRequest.tenantId = dataSet ? dataSet.TenantID : '';

                remoteUrl = utils.GetSalesReviewRemoteServer();
                remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');

                // Exact Agirs Error Message Show and Custom Message
                remoteUrl = `${remoteUrl}/Bookings/bookingAndPost`;
                // remoteUrl = `${utils.GetSalesReviewRemoteServer()}/Bookings/bookingAndPost`;
            }

            this.helper.Post((data) => {
                // if (body.approveBookingRequest.status != "V" && body.isAutoApprove == true && body.isQuoteConverted == true && !body.isSameNumber) {
                //     this.postBooking(body, true);
                // } else {
                //     data.isAutoApprove = body.isAutoApprove;
                //     resolve(data)
                // }

                data.isAutoApprove = body.isAutoApprove;
                resolve(data)
            }, remoteUrl, body, null, null, null, (error) => { reject(error) }, false);
        })
    }
    postsplitBooking(splits, isLocation = false): Promise<any> {

        return new Promise((resolve, reject) => {
            let remoteUrl = utils.GetSalesReviewRemoteServer();
            let url;
            remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');
            splits.forEach((body) => {
                if(!isLocation)
                    body.location = utils.getLocation();
                body.isFromSalesApp = true;
                // body.isFromSalesApp = true;
                // let remarksLength = 250;
                // if (body.bookingBook && (body.pendingAgreementConfig || body.bookingBook.bookingProgram)) {
                //     if (body.pendingAgreementConfig && !body.bookingBook.bookingProgram) {
                //         this.mapBookingRemarks(body.bookingBook, remarksLength);
                //     } else {
                //         this.mapBookingRemarks(body.bookingBook, remarksLength - 50);
                //     }
                // }
                // else if (body.bookingPrepay && body.pendingAgreementConfig) {
                //     this.mapPrepayRemarks(body.bookingPrepay, remarksLength);
                // }

                if (body.bookingBook)
                    this.fillBookingRemarks(body);
                else if (body.bookingPrepay)
                    this.fillPrepayRemarks(body);
                else if (body.bookingQuote) {
                    this.fillQuoteRemarks(body);
                }

                let dataSet: any = this.storage.get(StorageKeys.DataSet);
                let agrisLicense = JSON.parse(localStorage.getItem('agrisLicense'));
                let settings = this.storage.get(StorageKeys.Settings);;
                var userId = agrisLicense.username;

                var User = {
                    "UserId": userId
                };
                body.User = User;
                body.AgentId = localStorage.getItem('AgentId');
                body.TenantId = this.storage.get(StorageKeys.DataSet).TenantID;

                url = `${remoteUrl}/Bookings/splitbooking`;

                if (body.isAutoApprove) {
                    let IsSameNumber = localStorage.getItem('isSameBookingNumber') === 'true' ? true : false;
                    let IsProUser = this.cryptoService.dencryptString(localStorage.getItem('ProUser')) === 'true' ? true : false;
                    body.approveBookingRequest.status = "";
                    // same booking number  => pro user -> type booking -> Asr Same number  true 
                    //body.approveBookingRequest.isSameNumber = (IsProUser == true && IsSameNumber == true && body.bookingBook && body.bookingNumber && body.isQuoteConverted == true) ? true : false;
                    /// booking number is empty do we need to check booking number over here ???
                    body.approveBookingRequest.isSameNumber = (IsProUser == true && IsSameNumber == true && body.bookingBook && body.isQuoteConverted == true) ? true : false;

                    body.approveBookingRequest.sessionId = settings ? settings.agentSessionId : '';
                    if (agrisLicense) {
                        body.approveBookingRequest.user = agrisLicense.username;
                        body.approveBookingRequest.password = agrisLicense.password;
                        body.approveBookingRequest.decryptedPassword = agrisLicense.beforeEncrptPassword;
                        body.approveBookingRequest.agrisSession = agrisLicense.agrisLicense;
                    }
                    body.approveBookingRequest.tenantId = dataSet ? dataSet.TenantID : '';
                    // Exact Agirs Error Message Show
                    url = `${remoteUrl}/Bookings/splitbookingAndApprove`;
                }
                else if (body.approveBookingRequest.status) {
                    body.approveBookingRequest.sessionId = settings ? settings.agentSessionId : '';
                    if (agrisLicense) {
                        body.approveBookingRequest.user = agrisLicense.username;
                        body.approveBookingRequest.password = agrisLicense.password;
                        body.approveBookingRequest.decryptedPassword = agrisLicense.beforeEncrptPassword;
                        body.approveBookingRequest.agrisSession = agrisLicense.agrisLicense;
                    }
                    body.approveBookingRequest.tenantId = dataSet ? dataSet.TenantID : '';

                    // Exact Agirs Error Message Show and Custom Message
                    url = `${remoteUrl}/Bookings/splitbookingAndPost`;
                    // remoteUrl = `${utils.GetSalesReviewRemoteServer()}/Bookings/bookingAndPost`;
                }
            });
            let request = new SplitBookingRequest();
            request.bookings = JSON.parse(JSON.stringify(splits));
            this.helper.Post((response) => {
                response.forEach(data => {
                    data.isAutoApprove = splits[0].isAutoApprove;
                })
                resolve(response)
            }, url, request, null, null, null, (error) => { reject(error) }, false);
        });

    }
    voidBooking(body): Promise<any> {

        return new Promise((resolve, reject) => {

            let agrisLicense = JSON.parse(localStorage.getItem('agrisLicense'));
            let settings = this.storage.get(StorageKeys.Settings);;
            var userId = agrisLicense.username;
            let remoteUrl = utils.GetSalesReviewRemoteServer();
            remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');
            remoteUrl = `${remoteUrl}/Bookings/approvebooking`;
            let IsSameNumber = localStorage.getItem('isSameBookingNumber') === 'true' ? true : false;
            let IsProUser = this.cryptoService.dencryptString(localStorage.getItem('ProUser')) === 'true' ? true : false;

            var voidBooking = {
                Id: body.bookingId,
                User: userId,
                Password: agrisLicense.password,
                AgrisSession: agrisLicense.agrisLicense,
                // SessionId: settings ? settings.agentSessionId : '',
                TenantId: this.storage.get(StorageKeys.DataSet).TenantID,
                Status: "V",
                isSameNumber: (IsProUser == true && IsSameNumber == true && body.bookingBook && body.bookingNumber && body.isQuoteConverted == true) ? true : false,
                SalesAppVoid: true
            };
            this.helper.Post((data) => { resolve(data) }, remoteUrl, voidBooking, null, settings ? settings.agentSessionId : '', null, (error) => { reject(error) }, false);
        });
    }
    printBooking(bookingId: any, getPDF: boolean = false, downloadPDF: boolean = false, callback: any, errorCallback: any) {

        let dataSet: any = this.storage.get(StorageKeys.DataSet);
        let agrisLicense = JSON.parse(localStorage.getItem('agrisLicense'));
        let settings = this.storage.get(StorageKeys.Settings);
        let userId = agrisLicense.username;
        let remoteUrl = utils.GetSalesReviewRemoteServer();
        remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');
        remoteUrl = `${remoteUrl}/Bookings/print`;
        let User = {
            "UserId": userId
        };

        let body = new PrintBookingPDF();
        body.Id = bookingId;
        body.AgrisSession = agrisLicense.agrisLicense;
        body.BankCode = "";
        body.Password = agrisLicense.password;
        body.TenantId = this.storage.get(StorageKeys.DataSet).TenantID
        body.SessionId = settings ? settings.agentSessionId : '';
        body.User = userId;
        body.getPDF = getPDF;
        body.DownloadPDF = downloadPDF;
        // body.User = User;
        // body.AgentId = localStorage.getItem('AgentId');
        // body.TenantId = this.storage.get(StorageKeys.DataSet).TenantID;
        // if (body.approveBookingRequest.status) {
        //     body.approveBookingRequest.sessionId = settings ? settings.agentSessionId : '';
        //     if (agrisLicense) {
        //         body.approveBookingRequest.user = agrisLicense.username;
        //         body.approveBookingRequest.password = agrisLicense.password;
        //         body.approveBookingRequest.decryptedPassword = agrisLicense.beforeEncrptPassword;
        //         body.approveBookingRequest.agrisSession = agrisLicense.agrisLicense;
        //     }
        //     body.approveBookingRequest.tenantId = dataSet ? dataSet.TenantID : '';

        //     remoteUrl = utils.GetSalesReviewRemoteServer();
        //     remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');
        //     remoteUrl = `${remoteUrl}/Bookings/print`;
        // }
        this.helper.Post((data) => { callback(data) }, remoteUrl, body, null, null, null, (error) => { errorCallback(error) }, false, false, true);
    }



    printAndDownloadBooking(bookingId: any, getPDF: boolean = false, downloadPDF: boolean = true, PendingBooking: boolean = true, ApproveBooking: boolean = true, callback: any, errorCallback: any) {

        let dataSet: any = this.storage.get(StorageKeys.DataSet);
        let agrisLicense = JSON.parse(localStorage.getItem('agrisLicense'));
        let settings = this.storage.get(StorageKeys.Settings);
        let userId = agrisLicense.username;
        let remoteUrl = utils.GetSalesReviewRemoteServer();
        remoteUrl = remoteUrl.startsWith('https://') ? remoteUrl.replace('https://', '') : remoteUrl.replace('http://', '');
        remoteUrl = `${remoteUrl}/Bookings/GetPrintAndDownloadForm`;
        let User = {
            "UserId": userId
        };
        let customerKey = settings.customerKey;
        let body = new PrintBookingPDF();
        body.Id = bookingId;
        body.AgrisSession = agrisLicense.agrisLicense;
        body.BankCode = "";
        body.Password = agrisLicense.password;
        body.TenantId = this.storage.get(StorageKeys.DataSet).TenantID
        body.SessionId = settings ? settings.agentSessionId : '';
        body.User = userId;
        body.getPDF = getPDF;
        body.DownloadPDF = downloadPDF;
        body.Approved = ApproveBooking;
        body.Pending = PendingBooking;

        this.helper.Post((data) => { callback(data) }, remoteUrl, body, null, null, null, (error) => { errorCallback(error) }, false);




    }


    private generateEmptyRemarks() {
        let remarks: any = "";
        for (let i = 0; i < 300; i++) {
            remarks += " ";
        }
        return remarks;
    };
    private mapBookingRemarks(data: BookingBookModel, remarksLength: number) {
        let remarks: any = "";
        if (data.bookingProgram.length < 50 && data.bookingProgram.length > 0) {
            let diff = 50 - data.bookingProgram.length;
            for (let i = 0; i < diff; i++) {
                data.bookingProgram += " ";
            }
        }

        if (data.bookRemarks.length === 0) {
            for (let i = 0; i < remarksLength; i++) {
                remarks += " ";
            }
            remarks += data.bookingProgram;
        }
        else if (data.bookRemarks.length <= remarksLength) {
            remarks += data.bookRemarks;
            let diff = remarksLength - data.bookRemarks.length;
            for (let i = 0; i < diff; i++) {
                remarks += " ";
            }
            remarks += data.bookingProgram;
        }
        data.bookRemarks = remarks;
        console.log(data.bookRemarks);
    }
    private mapPrepayRemarks(data: BookingPrepayModel, remarksLength: number) {
        let remarks: any = "";
        if (data.prepayRemarks.length === 0) {
            for (let i = 0; i < remarksLength; i++) {
                remarks += " ";
            }
        }
        else if (data.prepayRemarks.length <= remarksLength) {
            remarks += data.prepayRemarks;
            let diff = remarksLength - data.prepayRemarks.length;
            for (let i = 0; i < diff; i++) {
                remarks += " ";
            }
        }
        else {
            remarks = data.prepayRemarks;
        }
        data.prepayRemarks = remarks;
        console.log(data.prepayRemarks);
    }

    private fillBookingRemarks(body: any) {
        // console.log("BookingProgram",body.remarksNumberForBookingProgram);
        // console.log("FarmAndField",body.remarksNumberForFarmAndField);
        if (body.isQuoteConverted) return;

        //fill booking remarks
        let spaces = 0;
        spaces = 150 - body.bookingBook.bookRemarks.length;
        for (let i = 0; i < spaces; i++) {
            body.bookingBook.bookRemarks += " ";
        }

        let farmAndFieldValue = body.fieldName ? `${body.farmName} - ${body.fieldName}` : body.farmName;
        farmAndFieldValue = !farmAndFieldValue ? "" : farmAndFieldValue;
        spaces = 50 - farmAndFieldValue.length;
        for (let i = 0; i < spaces; i++) {
            farmAndFieldValue += " ";
        }

        let bookingProgramValue = body.bookingBook.bookingProgram ? body.bookingBook.bookingProgram : "";
        spaces = 50 - bookingProgramValue.length;
        for (let i = 0; i < spaces; i++) {
            bookingProgramValue += " ";
        }

        if (body.remarksNumberForBookingProgram == 5 && body.remarksNumberForFarmAndField == 4) {
            body.bookingBook.bookRemarks = body.bookingBook.bookRemarks + farmAndFieldValue + bookingProgramValue;
        } else if (body.remarksNumberForBookingProgram == 4 && body.remarksNumberForFarmAndField == 5) {
            body.bookingBook.bookRemarks = body.bookingBook.bookRemarks + bookingProgramValue + farmAndFieldValue;
        }



        // if (body.isQuoteConverted) return;
        // let spaces = 0;

        // spaces = 150 - body.bookingBook.bookRemarks;
        // for (let i = 0; i < spaces; i++) {
        //     body.bookingBook.bookRemarks += " ";
        // }

        // // Fill remarks 4 (FarmAndFiledValue)
        // let farmAndFieldRemark = '';
        // if (body.farm)
        //     farmAndFieldRemark = body.field ? `${body.farm} - ${body.field}` : body.farm;

        // spaces = 50 - farmAndFieldRemark.length;
        // for (let i = 0; i < spaces; i++) {
        //     farmAndFieldRemark += " ";
        // }
        // body.bookingBook.bookRemarks += farmAndFieldRemark;

        // // Fill remarks 5 (BookingProgram)
        // let bookProgramRemark = body.bookingBook.bookingProgram;
        // spaces = 50 - bookProgramRemark.length;
        // for (let i = 0; i < spaces; i++) {
        //     bookProgramRemark += " ";
        // }
        // body.bookingBook.bookRemarks += bookProgramRemark;


        // // Fill remarks 6 (PrintAgreement)
        // // let printAgreementRemark = "";
        // // spaces = 50 - printAgreementRemark.length;
        // // for (let i = 0; i < spaces; i++) {
        // //     printAgreementRemark += " ";
        // // }
        // // body.bookingBook.bookRemarks += printAgreementRemark;
    }

    private fillPrepayRemarks(body: any) {
        if (body.isQuoteConverted) return;

        //fill prepay remarks
        let spaces = 0;
        spaces = 150 - body.bookingPrepay.prepayRemarks.length;
        for (let i = 0; i < spaces; i++) {
            body.bookingPrepay.prepayRemarks += " ";
        }

        // let farmAndFieldValue = body.field ? `${body.farm} - ${body.field}` : body.farm;
        let farmAndFieldValue = body.fieldName ? `${body.farmName} - ${body.fieldName}` : body.farmName;
        farmAndFieldValue = !farmAndFieldValue ? "" : farmAndFieldValue;
        spaces = 50 - farmAndFieldValue.length;
        for (let i = 0; i < spaces; i++) {
            farmAndFieldValue += " ";
        }

        let bookingProgramValue = body.bookingPrepay.bookingProgram ? body.bookingPrepay.bookingProgram : "";
        spaces = 50 - bookingProgramValue.length;
        for (let i = 0; i < spaces; i++) {
            bookingProgramValue += " ";
        }

        if (body.remarksNumberForBookingProgram == 5 && body.remarksNumberForFarmAndField == 4) {
            body.bookingPrepay.prepayRemarks = body.bookingPrepay.prepayRemarks + farmAndFieldValue + bookingProgramValue;
        } else if (body.remarksNumberForBookingProgram == 4 && body.remarksNumberForFarmAndField == 5) {
            body.bookingPrepay.prepayRemarks = body.bookingPrepay.prepayRemarks + bookingProgramValue + farmAndFieldValue;
        }


        // if (body.isQuoteConverted) return;
        // let spaces = 0;

        // spaces = 150 - body.bookingPrepay.prepayRemarks.length;
        // for (let i = 0; i < spaces; i++) {
        //     body.bookingPrepay.prepayRemarks += " ";
        // }

        // // Fill remarks 4 (FarmAndFiledValue)
        // let farmAndFieldRemark = '';
        // if (body.farm)
        //     farmAndFieldRemark = body.field ? `${body.farm} - ${body.field}` : body.farm;

        // spaces = 50 - farmAndFieldRemark.length;
        // for (let i = 0; i < spaces; i++) {
        //     farmAndFieldRemark += " ";
        // }
        // body.bookingPrepay.prepayRemarks += farmAndFieldRemark;

        // // Fill remarks 5 (BookingProgram)
        // let bookProgramRemark = body.bookingPrepay.bookingProgram ? body.bookingPrepay.bookingProgram : "";
        // spaces = 50 - bookProgramRemark.length;
        // for (let i = 0; i < spaces; i++) {
        //     bookProgramRemark += " ";
        // }
        // body.bookingPrepay.prepayRemarks += bookProgramRemark;


        // // Fill remarks 6 (PrintAgreement)
        // // let printAgreementRemark = "";
        // // spaces = 50 - printAgreementRemark.length;
        // // for (let i = 0; i < spaces; i++) {
        // //     printAgreementRemark += " ";
        // // }
        // // body.bookingPrepay.prepayRemarks += printAgreementRemark;
    }
    private fillQuoteRemarks(body: any) {
        // console.log("BookingProgram",body.remarksNumberForBookingProgram);
        // console.log("FarmAndField",body.remarksNumberForFarmAndField);
        if (body.isQuoteConverted) return;

        //fill booking remarks
        let spaces = 0;
        spaces = 150 - body.bookingQuote.remarks.length;
        for (let i = 0; i < spaces; i++) {
            body.bookingQuote.remarks += " ";
        }

        let farmAndFieldValue = body.fieldName ? `${body.farmName} - ${body.fieldName}` : body.farmName;
        farmAndFieldValue = !farmAndFieldValue ? "" : farmAndFieldValue;
        spaces = 50 - farmAndFieldValue.length;
        for (let i = 0; i < spaces; i++) {
            farmAndFieldValue += " ";
        }

        let bookingProgramValue = body.bookingQuote.bookingProgram ? body.bookingQuote.bookingProgram : "";
        spaces = 50 - bookingProgramValue.length;
        for (let i = 0; i < spaces; i++) {
            bookingProgramValue += " ";
        }

        if (body.remarksNumberForBookingProgram == 5 && body.remarksNumberForFarmAndField == 4) {
            body.bookingQuote.remarks = body.bookingQuote.remarks + farmAndFieldValue + bookingProgramValue;
        } else if (body.remarksNumberForBookingProgram == 4 && body.remarksNumberForFarmAndField == 5) {
            body.bookingQuote.remarks = body.bookingQuote.remarks + bookingProgramValue + farmAndFieldValue;
        }
    }


    ValidateAgentSession(): Promise<any> {

        let date = moment.utc(Date.now()).local();
        let formateddate = date.format("MM/DD/YYYY hh:mm A");
        let AgentSessionTime = localStorage.getItem("AgentSessionUpdateTime");
        let AgrisVersion = localStorage.getItem("AgrisVersion");

        let settings = this.storage.get(StorageKeys.Settings);

        if (AgentSessionTime && AgrisVersion) {
            let AgentSessionToDate = new Date(AgentSessionTime)
            let CurrentTimeStringToDate = new Date(formateddate)

            if (CurrentTimeStringToDate > AgentSessionToDate) {
                let _30minAddinTime = moment(CurrentTimeStringToDate).add(30, 'm');
                let _30minFormatedDate = _30minAddinTime.format("MM/DD/YYYY hh:mm A")

                return new Promise((resolve, reject) => {
                    var agentInfo = JSON.parse(localStorage.settings);
                    var headers = {
                        SessionID: agentInfo.agentSessionId,
                        'Content-Type': 'application/json'
                    };
                    let gatewayURL = utils.GetGetwayRemoteServer();
                    let remoteUrl = gatewayURL.startsWith('https://') ? gatewayURL.replace('https://', '') : gatewayURL.replace('http://', '');
                    let url = 'culturahub/RESTCommandWebService/ExecuteServerCommand/AgentProcessor/Version';

                    this.helper.Get(remoteUrl + url, settings.customerKey, settings ? settings.agentSessionId : '', null, (response) => {
                        if (response.System) {
                            localStorage.setItem("AgrisVersion", JSON.parse(decodeURI(response.System)).Version);
                        }

                        localStorage.setItem("AgentSessionUpdateTime", _30minFormatedDate);
                        resolve(true);
                    }, (error) => {
                        reject(error.error);
                    })

                });
            } else {
                return new Promise((resolve, reject) => { resolve(true); })
            }
        }
        else {
            let _30minAddinTime = moment(date).add(30, 'm');
            let _30minFormatedDate = _30minAddinTime.format("MM/DD/YYYY hh:mm A")
            localStorage.setItem("AgentSessionUpdateTime", _30minFormatedDate);
            return new Promise((resolve, reject) => {
                var agentInfo = JSON.parse(localStorage.settings);
                var headers = {
                    SessionID: agentInfo.agentSessionId,
                    'Content-Type': 'application/json'
                };

                let gatewayURL = utils.GetGetwayRemoteServer();
                let remoteUrl = gatewayURL.startsWith('https://') ? gatewayURL.replace('https://', '') : gatewayURL.replace('http://', '');
                let url = 'culturahub/RESTCommandWebService/ExecuteServerCommand/AgentProcessor/Version';

                this.helper.Get(remoteUrl + url, settings.customerKey, settings ? settings.agentSessionId : '', null, (response) => {
                    if (response.System) {
                        localStorage.setItem("AgrisVersion", JSON.parse(decodeURI(response.System)).Version);
                    }

                    localStorage.setItem("AgentSessionUpdateTime", _30minFormatedDate);
                    resolve(true);
                }, (error) => {
                    reject(error.error);
                })
            });
        }




    }




}
